export default __webpack_public_path__ + "e896ec01733bad7aba832c51a2dd6f02.svg";